import { PagedFilterAndSortedRequest } from '../../dto/pagedFilterAndSortedRequest';
import { ServiceGroup } from './serviceGroup';

export interface Service {
  id: number;
  code?: string;
  name: string;
  normalizedName?: string;
  description?: string;
  discount: number;
  duration: number;
  price: number;
  isFixed: boolean;
  isVat: boolean;
  vat: number;
  isActive: boolean;
  serviceGroupId: number;
  serviceGroup?: ServiceGroup;
  serviceParts: ServicePart[];
  tenantId?: number;
  note?: string;
}

export interface UpdateService {
  id: number;
  code?: string;
  name?: string;
  description?: string;
  isActive?: boolean;
  isVat: boolean;
  isFixed: boolean;
  duration: number;
  price: number;
  discount?: number;
  tenantId?: number;
  serviceGroupId: number;
  serviceParts?: ServicePart[];
}

export interface CreateUpdateService {
  id: number;
  code?: string;
  name?: string;
  normalizedName?: string;
  description?: string;
  isActive: boolean;
  isVat: boolean;
  isFixed: boolean;
  duration: number;
  price: number;
  discount?: number;
  tenantId?: number;
  serviceGroupId: number;
  serviceParts?: ServicePart[];
}

export interface ServicePart {
  serviceId?: number;
  name: string;
  type: string;
  discount?: number;
  quantity?: number;
  price?: number;
  costPrice?: number;
  margin?: number;
  vat?: number;
}

export interface DispachedServicePart {
  serviceId?: number;
  name: string;
  type: string;
  number?: string;
  reference?: string;
  quantity?: number;
  discount?: number;
  price?: number;
  costPrice?: number;
  margin?: number;
  vat?: number;
  required: boolean;
  inventoryId?: string;
  /** Client-only snapshot of stock at the moment of selection from inventory.
   *  Used to warn when the user increases quantity beyond what's available. */
  availableStock?: number;
}

export const InitialServicePart = {
  name: '',
  type: '',
  serviceId: undefined,
  quantity: undefined,
  discount: undefined,
  price: undefined,
  costPrice: undefined,
  margin: undefined,
  vat: undefined,
  required: false,
};

export interface ServiceSelect {
  id: number;
  name: string;
}

export interface PagedServiceRequest extends PagedFilterAndSortedRequest {
  name?: string | null;
  code?: string | null;
  serviceGroupId?: number | null;
  groupName?: string | null;
  isVat?: boolean | null;
  isActive?: boolean | null;
  showMyServicesOnly?: boolean;
}

export interface PagedSelectServiceRequest extends PagedFilterAndSortedRequest {
  name?: string | null;
  isActive?: boolean;
  normalizedName?: string | null;
  showMyServicesOnly?: boolean;
  fixedOnly?: boolean;
}
